import React, { useEffect, Suspense } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Login = React.lazy(() => import("./pages/Login"));
const BusinessPlan = React.lazy(() => import("./pages/BusinessPlan"));
const Legal = React.lazy(() => import("./pages/Legal"));
const CropBooster = React.lazy(() => import("./pages/CropBooster"));
const LadyGrow = React.lazy(() => import("./pages/LadyGrow"));
const BuletStar = React.lazy(() => import("./pages/BuletStar"));
const YoungCrop = React.lazy(() => import("./pages/YoungCrop"));

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    });
  }, []);

  return (
    <Router>
      <Navbar />

      <Suspense fallback={<div className="text-center py-5">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/business-plan" element={<BusinessPlan />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/crop-booster" element={<CropBooster />} />
          <Route path="/lady-grow" element={<LadyGrow />} />
          <Route path="/bulet-star" element={<BuletStar />} />
          <Route path="/young-crop" element={<YoungCrop />} />
        </Routes>
      </Suspense>

      <Footer />
    </Router>
  );
}

export default App;